/* Code generated with AutoHTML Plugin for Figma */
import { UserFrontPrivate } from "@project/shared-types";
import { useMemo } from "react";
import { useLocation } from "react-router";
import ProfileSvg from "../../assets/taiga-uikit/icons/user-octagon.svg?react";
import { DiscontNewUser } from "../../blocks/PersonDiscont/DiscontNewUser";
import { useUser } from "../../context/user/useUser";
import { _size, _style } from "../../core/core";
import { useLocalStorage } from "../../hooks/useLocalStoreg";
import { Logo } from "../Logo/Logo";
import { Tab } from "../Tab/Tab";
import { Link } from "../link/link";
import "./header.css";

const Header = () => {
  const user = useUser();

  const [email, setEmail] = useLocalStorage("email", "");
  const email_user = useMemo(() => {
    if (user)
      if (user.email) return user.email;
      else if (email && email.includes("@")) return email;
    return undefined;
  }, [user, email]);
  const getEmailName = (user: UserFrontPrivate): string => {
    try {
      if (user) if (user.email) return user.email.split("@")[0];
    } catch (error) {
      return "Авторизация";
    }
    return "Авторизация";
  };
  // const isWarning = () => {
  //   const currentDate = new Date();
  //   const targetDate = new Date(2025, 0, 11); // Months are zero-indexed, so 0 is January
  //   return currentDate.toDateString() === targetDate.toDateString();
  // };
  const currentPage = useLocation();
  const is_uslugi = currentPage.pathname.includes("uslugi");
  return (
    <>
      <div className="header-block">
        <div className="header">
          <div className="hedaer-left">
            <Logo></Logo>
            <div className="left-group">
              <Tab
                stroke={currentPage.pathname == "/uslugi/"}
                text="Услуги"
                link="/uslugi/"
              ></Tab>
              <Tab
                stroke={currentPage.pathname == "/blog/"}
                text="Блог"
                link="/blog/"
              ></Tab>
            </div>
          </div>
          {user ? (
            <div className="header-right">
              <Link link={"/account/"} size={_size.M}>
                {getEmailName(user)}
              </Link>
            </div>
          ) : (
            <div className="header-right">
              <Link
                link={`${is_uslugi
                  ? `${currentPage.pathname}#fast_payment`
                  : "/uslugi/"
                  }#fast_payment`}
                size={_size.M}
              >
                Заказать
              </Link>
              <Link
                link={`/account/`}
                style={_style.outline}
                size={_size.M}
                icon_left={<ProfileSvg />}
              >
                Вход
              </Link>
            </div>
          )}
        </div>
        {email_user && <DiscontNewUser header={true} email={email_user} />}
        {/* {isWarning() && <WarningSite></WarningSite>} */}
      </div>
    </>
  );
};

export default Header;
